export const BUSINESS_FIELDS = [
  { field: 'address' },
  { field: 'addressOptional' },
  { field: 'city' },
  { field: 'country' },
  { field: 'name' },
  { field: 'phone' },
  { field: 'state' },
  { field: 'zip' },
];

export const CANADIAN_PROVINCES = [
  'AB',
  'BC',
  'MB',
  'NB',
  'NL',
  'NT',
  'NS',
  'NU',
  'ON',
  'PE',
  'QC',
  'SK',
  'YT',
];
export const US_STATES = [
  'AL',
  'AK',
  'AS',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FM',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MH',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'MP',
  'OH',
  'OK',
  'OR',
  'PW',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VI',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

export const AUSTRALIAN_COUNTRY_CODE = 'AU';
export const CANADIAN_COUNTRY_CODE = 'CA';
export const US_COUNTRY_CODE = 'US';

export const COUNTRY_OPTIONS = [
  { displayValue: 'Canada', id: CANADIAN_COUNTRY_CODE },
  { displayValue: 'United States', id: US_COUNTRY_CODE },
];

export const TRIAL_BUSINESS_BUTTON_ID = 'TrialBusinessButton-submit-btn';
export const TRIAL_BUSINESS_BUTTON_TEST_ID = 'trial-business-button';

export const TRIAL_BUSINESS_TITLE = "What's the name of your business?";
export const ADD_BUSINESS_DETAILS_TITLE =
  'Welcome! Add some details about your business.';
export const VERIFY_BUSINESS_DETAILS_TITLE =
  'Welcome! Verify your business details.';
